import { pdfjs } from "react-pdf";

// ⛔️ ne pas utiliser le CDN ici
pdfjs.GlobalWorkerOptions.workerSrc = "/pdfjs/pdf.worker.min.js";
